import {environment} from '../../../environments/environment';

export interface RecommendationDate {
  date: string;
  timezone_type: number;
  timezone: string;
}

export interface Recommendation {
  id: number;
  title_es: string;
  title_en: string;
  title_fr: string;
  subtitle_es: string;
  subtitle_en: string;
  subtitle_fr: string;
  description_es: string;
  description_en: string;
  description_fr: string;
  address: string;
  latitude: string;
  longitude: string;
  phone: string;
  web: string;
  image: string;
  image_ppal: string;
  apartment_id: number;
  created_at: RecommendationDate;
  updated_at: RecommendationDate;
  km: string;
}

export type Recommendations = Recommendation[];

function getRecommendationTitleByLanguage(recommendation: Recommendation, lang: string): string {
  return recommendation[`title_${lang}` as keyof Recommendation] as string ||
    recommendation[`title_${environment.defaultAppLang}` as keyof Recommendation] as string;
}

function getRecommendationSubtitleByLanguage(recommendation: Recommendation, lang: string): string {
  return recommendation[`subtitle_${lang}` as keyof Recommendation] as string ||
    recommendation[`subtitle_${environment.defaultAppLang}` as keyof Recommendation] as string;
}

function getRecommendationDescriptionByLanguage(recommendation: Recommendation, lang: string): string {
  return recommendation[`description_${lang}` as keyof Recommendation] as string ||
    recommendation[`description_${environment.defaultAppLang}` as keyof Recommendation] as string;
}

export function getRecommendationTitle(recommendation: Recommendation): string {
  return getRecommendationTitleByLanguage(recommendation, environment.defaultAppLang);
}

export function getRecommendationSubtitle(recommendation: Recommendation): string {
  return getRecommendationSubtitleByLanguage(recommendation, environment.defaultAppLang);
}

export function getRecommendationDescription(recommendation: Recommendation): string {
  return getRecommendationDescriptionByLanguage(recommendation, environment.defaultAppLang);
}

export function getRecommendationAddress(recommendation: Recommendation): string {
  return recommendation.address || '';
}

export function getRecommendationTopActions(recommendation: Recommendation): TopAction[] {
  const topActions: TopAction[] = [];
  if (recommendation.web) {
    topActions.push({
      id: 'web',
      label: 'Web',
      href: recommendation.web
    });
  }
  if (recommendation.phone) {
    topActions.push({
      id: 'phone',
      label: 'Teléfono',
      href: `tel:${recommendation.phone}`
    })
  }
  return topActions;
}
